module.exports = __webpack_public_path__ + "img/home-instructions-vip.e0b323f6.png";